import React, { useEffect, useState } from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import Share from "react-native-share";
import Text from "@components/AppText";
import { useSelector } from "react-redux";
import { leaderReferMessage } from "@services/api";

import colors from "@constants/color";

import CLToCLGraphic from "@assets/svg/CLToCLGraphic";
import CLShare from "@assets/svg/CLShare";
import { useNavigation } from "@react-navigation/native";
import t from "@constants/localization";
import { CLICK_REFER_LINK } from "../../constants/analyticsEvents";

const PATH = "components/Profile/LeaderReferLink";

const LeaderReferLink = (props) => {
  const navigation = useNavigation();
  const [referMessage, setReferMessage] = useState({});

  useEffect(() => {
    leaderReferMessage()
      .then(({ data }) => {
        setReferMessage(data);
      })
      .catch((error) => console.log(error));
  }, []);

  const { primary, secondary = "" } = referMessage || {};

  const {
    refer_cl_link = "",
    name = "",
    id: leader_id = "",
    phone_number: leader_phone = "",
  } = useSelector(({ auth: { user } }) => user);
  const leaderName = name && name.split(" ")[0];
  const message = t(`${PATH}/referMsgNLink`, {
    leaderName,
    refer_cl_link,
  });

  const onClickCLReferLink = async () => {
    const shareOptions = {
      title: "Share via",
      message,
      social: Share.Social.WHATSAPP,
      failOnCancel: false,
    };
    await Share.shareSingle(shareOptions);
  };

  const { shouldShowElevation = true } = props;

  return (
    <View
      style={{
        width: "100%",
        // paddingHorizontal: 15,
      }}
    >
      <View
        style={[styles.container, { elevation: shouldShowElevation ? 2 : 0 }]}
      >
        <View style={[styles.textContainer, { paddingBottom: 20 }]}>
          <Text fontType="content1">
            {(primary && primary.normal) || ""}
            <Text fontType="head3" bold>
              {(primary && ` ${primary.bold}`) || ""}
            </Text>
          </Text>
          <TouchableOpacity
            style={styles.buttonContainer}
            // onPress={() => onClickCLReferLink()}
            onPress={() => {
              navigation.navigate("ReferEarnScreen");
            }}
            eventName={CLICK_REFER_LINK}
            eventPayload={{
              leader_id,
              leader_name: name,
              leader_phone,
            }}
          >
            <CLShare />
            <Text
              fontType="content1"
              style={{ color: colors.white, marginLeft: 10 }}
            >
              {t(`${PATH}/refer`)}
            </Text>
          </TouchableOpacity>
          <Text
            fontType="content3"
            style={{
              color: "rgba(0, 0, 0, .5)",
            }}
          >
            {secondary}
          </Text>
        </View>

        <View style={styles.graphicContainer}>
          <CLToCLGraphic />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.white,
    elevation: 0,
    position: "relative",
    borderRadius: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 10,
  },
  textContainer: {
    width: "90%",
    marginHorizontal: 10,
    paddingVertical: 5,
  },
  buttonContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 10,
    backgroundColor: colors.primary,
    borderRadius: 10,
    padding: 10,
    width: 150,
    marginVertical: 10,
  },
  graphicContainer: {
    flex: 3,
    position: "absolute",
    right: 0,
    bottom: 0,
  },
});

export default LeaderReferLink;
